const TabSelector = require('./TabSelector');

module.exports = TabSelector;
